import { defineComponent as p, mergeModels as s, useModel as f, openBlock as c, createBlock as v, unref as g, createSlots as h, withCtx as n, withDirectives as $, createElementVNode as y, mergeProps as V, vModelDynamic as k, renderSlot as o } from "vue";
import C from "../InputContainer/v-input-container.vue.js";
/* empty css                                       */
const D = /* @__PURE__ */ p({
  inheritAttrs: !1,
  __name: "v-text-input",
  props: /* @__PURE__ */ s({
    type: { default: "text" },
    autocomplete: {},
    required: { type: Boolean },
    minlength: {},
    maxlength: {},
    pattern: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ s(["change"], ["update:modelValue"]),
  setup(l, { emit: r }) {
    const i = l, t = f(l, "modelValue"), m = r;
    function u() {
      m("change", t.value);
    }
    return (e, a) => (c(), v(g(C), null, h({
      input: n(() => [
        $(y("input", V({ class: "v-input" }, { ...e.$attrs, ...i }, {
          "onUpdate:modelValue": a[0] || (a[0] = (d) => t.value = d),
          onChange: u
        }), null, 16), [
          [k, t.value]
        ]),
        o(e.$slots, "input")
      ]),
      _: 2
    }, [
      e.$slots.start ? {
        name: "start",
        fn: n(() => [
          o(e.$slots, "start")
        ]),
        key: "0"
      } : void 0,
      e.$slots.end ? {
        name: "end",
        fn: n(() => [
          o(e.$slots, "end")
        ]),
        key: "1"
      } : void 0
    ]), 1024));
  }
});
export {
  D as default
};
